import controller from './mobile-connect.controller';

export default {
  bindings: {
    msisdn: '<',
    onError: '&',
    onSuccess: '&',
    redirectUri: '<'
  },
  controller,
  template: require('./mobile-connect.html')
};



// WEBPACK FOOTER //
// src/app/components/mobile-connect/mobile-connect.component.ts